import axios from 'axios';
import RestService from '../../helpers/RestService';
import moment from 'moment';
import {toastr} from 'react-redux-toastr'

axios.defaults.headers.common = {
  'Accept': 'application/json, text/plain',
  'X-CSRF-Token': RestService.getCsrfToken(),
  'X-Requested-With' : 'XMLHttpRequest',
};

export function getStudents() {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_KEY_STUDENT', key: "loaded", data: false});
      const {data} = await axios.get('/api/students/get');
      if(data.errcode == 200) {
        let students = data.payload || [];
        students = students.map((_s, index) => ({..._s, number: index + 1}));
        dispatch({type: 'GET_STUDENTS', data: students});
        return students;
      } else {
        throw new Error('Bag request')
      }
    } catch (error) {
    }
  }
}

export function createStudent(body) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_KEY_STUDENT', key: "loaded", data: false});
      const {data} = await axios.post('/api/student/post', body);
      if(data.errcode == 200) {
        dispatch({type: 'ADD_STUDENT', data: data.payload});
        toastr.success(data.title, data.message)
        return data.payload;
      } else {
        toastr.error('Error', data.message)
        return;
      }
    } catch (error) {
      
    }
  }
}

export async function sendInvite(body) {
  const {data} = await axios.post('/api/student/send-invite', body);
  if(data.errcode == 200) {
    return true;
  } else {
    throw new Error('Not send');
  }
}

export function deleteStudent(id) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_KEY_STUDENT', key: "loaded", data: false});
      const {data} = await axios.post('/api/student/delete', {id});
      
      if(data.errcode == 200) {
        dispatch({type: 'DELETE_STUDENT', data: data.payload})
        return data.payload;
      } else {
        throw new Error('Bag request')
      }
    } catch (error) {
      toastr.error('Error', 'Bag request')
    }
  }
}


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Students/actions.js